// 値は webpack の EnvironmentPlugin がビルド時に埋め込む（config/webpack/webpack.config.js）
const railsEnv = process.env.RAILS_ENV;
if (railsEnv === undefined) {
  throw new Error('環境変数 RAILS_ENV が設定されていません');
}

const copySourceBaseUrl = process.env.COPY_SOURCE_BASE_URL;
if (copySourceBaseUrl === undefined) {
  throw new Error('環境変数 COPY_SOURCE_BASE_URL が設定されていません');
}

const settings = {
  app: {
    railsEnv,
  },
  project: {
    copySourceBaseUrl,
  },
};

export default settings;
